import { defineNuxtPlugin } from 'nuxt/app';
import { setLocale } from 'yup';

export default defineNuxtPlugin({
	setup: () => {
		setLocale({
			mixed: {
				notNull: 'This field is required.',
				required: 'This field is required.',
				notType: 'This field is not of the correct type.',
				oneOf(params) {
					return `Please enter one of the following values: ${params.values}.`;
				},
			},
			date: {
				min(params) {
					return `Please enter a date on or after ${params.min}.`;
				},
				max(params) {
					return `Please enter a date on or before ${params.max}.`;
				},
			},
			array: {
				length(params) {
					return `Please enter ${params.length} items.`;
				},
				min(params) {
					return `Please select at least ${params.min} of the options.`;
				},
				max(params) {
					return `Please select at most ${params.max} of the options.`;
				},
			},
			number: {
				integer: 'Please enter an integer.',
				min(params) {
					return `Please enter a number greater than or equal to ${params.min}.`;
				},
				max(params) {
					return `Please enter a number less than or equal to ${params.max}.`;
				},
				lessThan(params) {
					return `Please enter a number less than ${params.less}.`;
				},
				moreThan(params) {
					return `Please enter a number greater than ${params.more}.`;
				},
				negative: 'Please enter a negative number.',
				positive: 'Please enter a positive number.',
			},
			string: {
				max(params) {
					return `Please enter at most ${params.max} characters.`;
				},
				min(params) {
					return `Please enter at least ${params.min} characters.`;
				},
				length(params) {
					return `Please enter ${params.length} characters.`;
				},
				email: 'Please enter a valid email address.',
				url: 'Please enter a valid URL.',
				trim: 'Please enter a non-empty string.',
				lowercase: 'Please enter a lowercase string.',
				uppercase: 'Please enter an uppercase string.',
				matches(params) {
					return `Please enter a string that matches the pattern ${params.regex}.`;
				},
				uuid: 'Please enter a valid UUID.',
			},
			boolean: {
				isValue() {

				},
			},
		});
	},
});

/*
export default defineNuxtPlugin({
	//	dependsOn: ['i18n:plugin'],
	setup: (/!* { $i18n } *!/) => {
		// const { t, d, locale } = $i18n as ReturnType<typeof useI18n>;

		// watch(locale, () => {
	/!*	setLocale({
			mixed: {
				required: t('validation.required'),
				notType: t('validation.notType'),
				oneOf(params) {
					return t('validation.oneOf', {
						values: params.values,
					});
				},
			},
			date: {
				min(params) {
					return t('validation.date.min', {
						min: d(params.min),
					});
				},
				max(params) {
					return t('validation.date.max', {
						max: d(params.max),
					});
				},
			},
			array: {
				length(params) {
					return t('validation.array.length', {
						length: params.length,
					});
				},
				min(params) {
					return t('validation.array.min', {
						min: params.min,
					});
				},
				max(params) {
					return t('validation.array.max', {
						max: params.max,
					});
				},
			},
			number: {
				integer: t('validation.number.integer'),
				min(params) {
					return t('validation.number.min', {
						min: params.min,
					});
				},
				max(params) {
					return t('validation.number.max', {
						max: params.max,
					});
				},
				lessThan(params) {
					return t('validation.number.lessThan', {
						less: params.less,
					});
				},
				moreThan(params) {
					return t('validation.number.moreThan', {
						more: params.more,
					});
				},
				negative: t('validation.number.negative'),
				positive: t('validation.number.positive'),
			},
			string: {
				max(params) {
					return t('validation.string.max', {
						max: params.max,
					});
				},
				min(params) {
					return t('validation.string.min', {
						min: params.min,
					});
				},
				length(params) {
					return t('validation.string.length', {
						length: params.length,
					});
				},
				email: t('validation.string.email'),
				url: t('validation.string.url'),
				trim: t('validation.string.trim'),
				lowercase: t('validation.string.lowercase'),
				uppercase: t('validation.string.uppercase'),
				matches(params) {
					return t('validation.string.matches', {
						matches: params.regex,
					});
				},
				uuid: t('validation.string.uuid'),
			},
		}); *!/
	//	}, { immediate: true });
	},
});
*/
